import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";

function AddDeliveryNoteForm({ setIsModalOpen, onDeliveryNoteUpdated }) {
  const [customer, setCustomer] = useState("");
  const [items, setItems] = useState([]);
  const [particulars, setParticulars] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [amountInWords, setAmountInWords] = useState(""); // Added state for amountInWords
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useAuth();
  const createdBy = user ? user.name : "";

  // Update totals when items change
  useEffect(() => {
    const calculatedTotal = items.reduce((sum, item) => sum + item.total, 0);
    setTotalAmount(calculatedTotal);
    const calculatedVat = Math.round(calculatedTotal * 0.18);
    setVat(calculatedVat);
    const finalTotal = calculatedTotal + calculatedVat;
    setFinalTotalAmount(finalTotal);
  }, [items]);

  const addItem = () => {
    if (particulars.trim() !== "" && quantity > 0 && rate > 0) {
      const total = parseFloat(quantity) * parseFloat(rate);
      setItems([...items, { particulars, quantity, rate, total }]);
      setParticulars("");
      setQuantity("");
      setRate("");
    }
  };

  const deleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const saveDeliveryNote = async () => {
    if (!customer.trim() || items.length === 0 || !amountInWords.trim()) {
      setErrorMessage("Please add a customer name and at least one item.");
      return;
    }

    const deliveryNoteData = {
      customer: { client: customer },
      items,
      deliveryNoteHeader: {
        // Changed from invoiceHeader
        companyName: "KEVMARK INVESTMENTS LTD",
        companyTIN: "1000135996",
        address:
          "Plot 59 Nkrumah-Nasser Link Plaza Nsooba, P.O. Box 71341 Kampala",
        phone: "0752 / 0772-551",
        email: ["kevmark2000@gmail.com", "sales@kevmarkinvestments.com"],
        description:
          "Stationary, Scholastic Materials, Toners, Computers, Computer Hardware and Software Maintenance",
      },
      deliveryNoteDetails: {
        // Changed from invoiceDetails
        date: new Date().toISOString().slice(0, 10),
        totalAmount: finalTotalAmount,
        vat,
        amountInWords,
      },
      createdBy,
    };

    console.log(deliveryNoteData);

    try {
      setIsLoading(true);
      await API.post("/deliverynotes", deliveryNoteData); // Changed endpoint
      setCustomer("");
      setItems([]);
      onDeliveryNoteUpdated(); // Changed callback name
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error saving delivery note:", error);
      setErrorMessage(
        `Failed to save delivery note: ${error.message || "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">

    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
        {/* <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto"> */}
        {/* 
        {isFetching && (
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
            <Spinner />
          </div>
        )} */}
        {/* Header (Static) */}
        <div className="">
          {/* Static Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Add New Delivery Note
          </h2>
          {/* Customer Name Input */}
          <div className="mb-4">
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full mb-2"
              placeholder="Customer Name"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
            />
          </div>
          <ErrorMessage message={errorMessage} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto space-y-3">
          {/* Items Input */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
            <input
              type="text"
              className="border border-gray-300 p-2 rounded"
              placeholder="Particulars"
              value={particulars}
              onChange={(e) => setParticulars(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded"
              placeholder="Qty"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded"
              placeholder="Rate (UGX)"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
            <button
              onClick={addItem}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add
            </button>
          </div>

          {/* Items Table */}
          <div className="flex-1 overflow-y-auto mb-4">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">Particulars</th>
                  <th className="border p-2">Qty</th>
                  <th className="border p-2">Rate (UGX)</th>
                  <th className="border p-2">Total (UGX)</th>
                  <th className="border p-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="text-center">
                    <td className="border p-2">{item.particulars}</td>
                    <td className="border p-2">{item.quantity}</td>
                    <td className="border p-2">{item.rate}</td>
                    <td className="border p-2">{item.total}</td>
                    <td className="border p-2">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-500 text-white px-2 py-1 rounded"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Grand Total */}
          {/* <div className="mt-4 text-right text-lg font-semibold">
        Total: UGX {totalAmount.toLocaleString()}
      </div>
       */}

          <div className="mt-4 text-right text-lg font-semibold text-gray-800">
            <p>Sub Total: USD {totalAmount.toLocaleString()}</p>
            <p>VAT 18%: USD {vat.toLocaleString()}</p>
            <p>Grand Total: USD {finalTotalAmount.toLocaleString()}</p>
          </div>

          <div>
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full my-2"
              placeholder="Amount in words"
              value={amountInWords}
              onChange={(e) => setAmountInWords(e.target.value)}
            />
          </div>
        </div>
        {/* Action buttons */}
        <div className="flex justify-end gap-3 mt-2 p-2">
          <button
            onClick={saveDeliveryNote}
            // className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              isLoading
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Submitting..." : "Save Delivery Note"}
          </button>
          <button
            onClick={() => setIsModalOpen(false)}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddDeliveryNoteForm;
